const getPerformanceDateString = (performanceTime) =>
    new Date(performanceTime + performance.timing.navigationStart).toString();

const getPerformanceNow = () => {
    return window.performance.now();
};

const getPerformanceNowInt = () => Math.round(getPerformanceNow());

const X_REQ_ID_HEADER = 'x-req-id';
const X_MCS_REQUEST_ID = 'X-MCS-Request-Id';
const X_BACKEND_TYPE = 'x-backend-type';

export const LogUtils = {
    getPerformanceDateString,
    getPerformanceNow,
    getPerformanceNowInt,
    X_REQ_ID_HEADER,
    X_MCS_REQUEST_ID,
    X_BACKEND_TYPE,
};
